export class OrderDepthExpansionModel {

    private constructor(public readonly bidPrice: number | null,
                        public readonly askPrice: number | null) {
    }

    public isBidExpanded(price: number): boolean {
        return this.bidPrice === price;
    }

    public isAskExpanded(price: number): boolean {
        return this.askPrice === price;
    }

    public toggleBidPrice(bidPrice: number): OrderDepthExpansionModel {
        const newBidPrice = (bidPrice === this.bidPrice) ? null : bidPrice;

        return new OrderDepthExpansionModel(newBidPrice, this.askPrice);
    }

    public toggleAskPrice(askPrice: number): OrderDepthExpansionModel {
        const newAskPrice = (askPrice === this.askPrice) ? null : askPrice;

        return new OrderDepthExpansionModel(this.bidPrice, newAskPrice);
    }

    public static empty(): OrderDepthExpansionModel {
        return new OrderDepthExpansionModel(null, null);
    }
}
